(function () {
  const MIN_ORDER_CENTS = 15000;

  let cartSubtotal = 0;

  async function fetchCartSubtotal() {
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
      const cart = await response.json();
      cartSubtotal = cart.items_subtotal_price || 0;
    } catch (error) {
      cartSubtotal = cartSubtotal || 0;
    }
  }

  function getQuantity(wrap) {
    const form = wrap.closest('form');
    const qtyInput = form?.querySelector('.quantity__input, input[name="quantity"]');
    const min = Number(qtyInput?.getAttribute('min') || 1);
    const value = Number(qtyInput?.value || min);
    return Math.max(min > 0 ? min : 1, value);
  }

  function isExpressAllowed(wrap, variantPriceCents) {
    const minimum = Number(wrap.dataset.minimumCents || MIN_ORDER_CENTS);
    const cart = Number(wrap.dataset.cartSubtotal ?? cartSubtotal);
    const quantity = getQuantity(wrap);
    const projected = cart + variantPriceCents * quantity;
    return projected >= minimum;
  }

  function updateWrap(wrap, variantPriceCents) {
    const price = variantPriceCents ?? Number(wrap.dataset.variantPrice || 0);
    wrap.dataset.variantPrice = String(price);

    const allowed = isExpressAllowed(wrap, price);
    wrap.hidden = !allowed;

    const notice = wrap.parentElement?.querySelector('[data-ksp-express-notice]');
    if (notice) {
      notice.hidden = allowed;
    }
  }

  function updateAll(variantPriceCents) {
    document.querySelectorAll('[data-ksp-express-checkout]').forEach((wrap) => {
      updateWrap(wrap, variantPriceCents);
    });
  }

  function syncCartSubtotalToDom() {
    document.querySelectorAll('[data-ksp-express-checkout]').forEach((wrap) => {
      wrap.dataset.cartSubtotal = String(cartSubtotal);
    });
  }

  function bindQuantityListeners() {
    document.querySelectorAll('.product-form__quantity input, .quantity__input').forEach((input) => {
      input.addEventListener('change', () => updateAll());
      input.addEventListener('input', () => updateAll());
    });
  }

  function init() {
    const wraps = document.querySelectorAll('[data-ksp-express-checkout]');
    if (!wraps.length) return;

    cartSubtotal = Number(wraps[0].dataset.cartSubtotal || 0);

    fetchCartSubtotal().then(() => {
      syncCartSubtotalToDom();
      updateAll();
    });

    bindQuantityListeners();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variantPrice = event?.data?.variant?.price;
        fetchCartSubtotal().then(() => {
          syncCartSubtotalToDom();
          updateAll(variantPrice);
        });
      });

      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        fetchCartSubtotal().then(() => {
          syncCartSubtotalToDom();
          updateAll();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
